<div class="restricted-width">
  <div class="page-title"><b>Llámanos |</b> Notificar Siniestro</div>
  <hr class="page-title-hr" />
  @if (!showFormulario) {
    <div class="filters-container">
      @if (isArcoprime) {
        <div class="filter-container">
          <div class="filter-title required">ID PAGADOR</div>
          <div class="filter">
            <ng-select
              [items]="pagadores"
              bindLabel="label"
              bindValue="id_pagador"
              [(ngModel)]="selectedPagador"
              (ngModelChange)="onPagadorChange($event)"
              [clearable]="false"
              [searchable]="true"
            />
          </div>
        </div>
      }
      <div class="filter-container">
        <div class="filter-title required">ESTACIÓN DE SERVICIO</div>
        <div class="filter">
          <ng-select
            [items]="edsOptions"
            bindLabel="label"
            bindValue="value"
            [(ngModel)]="selectedEstacion"
            (ngModelChange)="onEstacionChange($event)"
            [clearable]="false"
            [searchable]="false"
          />
        </div>
      </div>
    </div>
    <div
      class="siniestros-picker"
      [class.siniestros-picker--disabled]="selectedEstacion === null"
    >
      <div
        class="siniestro-item"
        [attr.data-tooltip]="
          selectedEstacion === null ? siniestroTooltip : null
        "
        *ngFor="let siniestro of activeSiniestros"
        (click)="siniestroClicked(siniestro)"
      >
        <img
          [src]="siniestro.icon"
          alt="Siniestro Icon"
          class="siniestro-icon"
        />
        <span class="siniestro-text">{{ siniestro.label.toUpperCase() }}</span>
      </div>
    </div>

    @if (
      Object.keys(allSiniestros).length > 0 && activeSiniestros.length == 0
    ) {
      <div class="no-subcategorias-message">
        <img
          src="assets/warning-rojo.svg"
          alt="Advertencia"
          class="no-subcategorias-icon"
        />
        <span>
          No hay subcategorías disponibles. Contáctenos a través del Contact
          Center.
        </span>
      </div>
    } @else {
      <div class="importante">
        <span class="importante-title">Importante: </span>
        Si consideras que tu problema no se ajusta a ninguna categoría, por
        favor contáctanos a través de nuestro Contact Center, esribenos por
        WhatsApp o envianos un correo.
      </div>
    }
  }
  @if (showFormulario) {
    <div style="margin-top: 16px">
      <app-formulario
        [subcategoria]="selectedSiniestro"
        [categoria]="'siniestro'"
        categoriaType="Siniestro"
        [selectedEstacion]="selectedEstacionComplete"
        (closeFormulario)="closeFormulario()"
        (finish)="finish($event)"
      >
      </app-formulario>
    </div>
  }
</div>
